import Vue from 'vue';
import eventBusWithPromise from './eventBusWithPromise';

Vue.prototype.$promiseBus = eventBusWithPromise;
